import { TDoctor, TBroker } from "@shared/entities";
import { useSyncExternalStore } from "react";

let listeners: any[] = [];

type AdminStore = {
	doctors: TDoctor[];
	brokers: TBroker[];
	setDoctors: (doctors: TDoctor[]) => void;
	setBrokers: (brokers: TBroker[]) => void;
	removeDoctor: (id: string) => void;
	removeBroker: (id: string) => void;
};
export let adminStore: AdminStore = {
	doctors: [],
	brokers: [],
	setDoctors(doctors: TDoctor[]) {
		adminStore.doctors = doctors;
		emitChange(adminStore);
	},
	setBrokers(brokers: TBroker[]) {
		adminStore.brokers = brokers;
		emitChange(adminStore);
	},
	removeDoctor(id: string) {
		adminStore.doctors = adminStore.doctors.filter(doctor => doctor.id !== id);
		emitChange(adminStore);
	},
	removeBroker(id: string) {
		adminStore.brokers = adminStore.brokers.filter(broker => broker.id !== id);
		emitChange(adminStore);
	},
};

function emitChange(store: AdminStore) {
	adminStore = { ...store };
	for (const listener of listeners) {
		listener();
	}
}

function subscribe(listener: any) {
	listeners = [...listeners, listener];
	return () => {
		listeners = listeners.filter((l) => l !== listener);
	};
}
function getSnapshot() {
	return adminStore;
}

export const useAdminStore = () => useSyncExternalStore(subscribe, getSnapshot, () => adminStore);
